import React from "react";
import { Table, Button } from "react-bootstrap";
import { Repeat } from "react-bootstrap-icons";
import ProductTagsTypes from "./ProductTagsTypes";
import SimilarProductsRow from "./SimilarProductsRow";
import { getSizeNameFromTypes } from "./utilities";

interface OrderProductsTableProps {
  trackingOrder: any;
  expandedRow: number | null;
  similarProducts: any;
  handleRowToggle: (index: number, productName: string) => void;
  setSwapProduct: any;
  saveSwapsButton?: React.ReactNode;
}

const OrderProductsTable: React.FC<OrderProductsTableProps> = (props) => {
  const {
    trackingOrder,
    expandedRow,
    similarProducts,
    handleRowToggle,
    setSwapProduct,
    saveSwapsButton,
  } = props;
  // Determinar si se debe mostrar la columna de cambio
  const showChangeColumn =
    handleRowToggle && handleRowToggle.toString() !== "() => {}";
  return (
    <Table className="text-center align-middle">
      <thead>
        <tr>
          {showChangeColumn && <th>Cambiar</th>}
          <th>Cantidad</th>
          <th className="text-start">Nombre</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        {trackingOrder &&
          Array.isArray(trackingOrder.saleDetails) &&
          trackingOrder.saleDetails.length > 0 &&
          trackingOrder.saleDetails.map((item: any, index: number) => [
            <tr
              key={index}
              style={{
                background: expandedRow === index ? "#f6fafd" : undefined,
              }}
            >
              {showChangeColumn && (
                <td>
                  <Button
                    className="text-black bg-transparent border-0"
                    onClick={() => handleRowToggle(index, item.product.name)}
                  >
                    <Repeat />
                  </Button>
                </td>
              )}
              <td>{item.quantity}</td>
              <td className="text-start">
                {item.product.name}{" "}
                {item.product.types?.length > 0 && (
                  <ProductTagsTypes
                    types={item.product.types}
                    excludeTypes={["Web"]}
                  />
                )}
              </td>
              <td>${item.total_amount}</td>
            </tr>,
            expandedRow === index && similarProducts ? (
              <tr key={index + "-similar"}>
                <td
                  colSpan={showChangeColumn ? 4 : 3}
                  style={{ padding: 0, borderTop: "none" }}
                >
                  <div
                    style={{
                      background: "#f6fafd",
                      borderRadius: 8,
                      margin: "0 0 8px 0",
                      padding: "18px 0 12px 0",
                      borderTop: "2px solid #e9ecef",
                      boxShadow: "0 1px 2px 0 rgba(0,0,0,0.02)",
                    }}
                  >
                    <SimilarProductsRow
                      loading={similarProducts.loading}
                      similarProducts={similarProducts.similarProducts}
                      originalProductId={item.product.id}
                      originalQuantity={item.quantity}
                      saleDetailId={item.id}
                      originalProductName={item.product.name}
                      originalProductSize={getSizeNameFromTypes(
                        item.product.types
                      )}
                      setSwapProduct={setSwapProduct}
                    />
                  </div>
                </td>
              </tr>
            ) : null,
          ])}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan={showChangeColumn ? 4 : 3} className="text-end">
            {saveSwapsButton}
          </td>
        </tr>
      </tfoot>
    </Table>
  );
};

export default OrderProductsTable;
